<template>
  <div class="top-distance">
    <div class="role-item-box" v-if="menuList.length > 1">
      <!-- <div class="modle-name">权限选择</div> -->
      <el-checkbox v-model="macheckAll" @change="handleCheckAllChange1" class="mb15">全选</el-checkbox>
    </div>
    <el-tree
      :data="managementData"
      show-checkbox
      default-expand-all
      node-key="menuId"
      ref="gltree"
      key="gl"
      highlight-current
      :props="defaultProps"
      @check="handleCheckChange"
      class="tree-box"
    >
    </el-tree>
  </div>
</template>
<script>
import {
  getLoginUserMenuByType,
  getSysRoleDetail,
} from "../../../../api/authorityManagement";

import getMenuDataBuild from "../../../../util/menuDataBuild";
import getMenuChildrenList from "@/util/menuChildren";
export default {
  props: {
    editRoleId: "",
    editMenuType: "",
  },
  watch: {
    editRoleId(val) {
      this.roleId = val;
    },
    editMenuType(val) {
      this.menuType = val;
    },
    selectedMenuList(val) {
      if (val.length == this.menuDataLength) {
        this.macheckAll = true;
      } else {
        this.macheckAll = false;
      }
    },
  },
  data() {
    return {
      roleId: this.editRoleId, //编辑的权限ID
      menuType: this.editMenuType, //菜单类型
      managementData: [], //管理权限
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      macheckAll: false,
      selectedMenuList: [],
      menuDataLength: 0, //菜单数据长度
      menuRoot: {}, //跟节点
      menuList: [], //数据库返回的menu数据
    };
  },
  mounted() {
    this.managementEcho();
  },
  methods: {
    handleCheckChange(data, checkedKeys) {
      this.setSectedMenuList();
    }, //管理权限全选
    handleCheckAllChange1(val) {
      // this.isIndeterminate = val
      // this.macheckAll = val
      // console.log(val,this.macheckAll,"this.macheckAllthis.macheckAll----")
      if (this.macheckAll) {
        this.$refs.gltree.setCheckedNodes(this.managementData);
      } else {
        this.$refs.gltree.setCheckedKeys([]);
      }
      this.setSectedMenuList();
    },
    setSectedMenuList() {
      this.selectedMenuList = [];
      // 管理权限
      // this.$refs.gltree.getCheckedNodes(false,true)
      let gltree = this.$refs.gltree
      //这里需要包涵半选中状态的
      let allMenuIds = [...gltree.getCheckedKeys()||[],...gltree.getHalfCheckedKeys()||[]];
      
      allMenuIds.forEach((val) => {
        this.selectedMenuList.push({ menuId: val });
      });
      // console.log(this.selectedMenuList,"this.selectedMenuList------1111111")
      this.$emit("change", this.selectedMenuList);
    },
    getSectedMenuList() {
      //...[{menuId:this.menuRoot.menuId}这个是在解决 提交的时候，默认把根节点带上
      //
      return [...this.selectedMenuList, this.menuRoot];
    },
    managementEcho() {
      let data = { menuType: this.menuType };
      // 这接口后台不需要返管理根权限最高级那个目录
      getLoginUserMenuByType(data).then((res) => {
        if (res.code == 1) {
          this.menuList = res.data;
          this.menuDataLength = res.data.length;

          let menuObject = getMenuDataBuild(res.data);
          this.menuRoot = menuObject.menuRoot;
          this.managementData = menuObject.menu.children;

          // if(this.menuType == 1) {
          //   let data = this.getAppList(this.menuList)
          //   this.managementData = data.slice(0,5)
          // } else {
          //   this.managementData = this.getAppList(this.menuList)
          // }
          if (this.roleId) {
            this.getSysRoleDetail();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    getAppList(menuData,num) {
      let arr = []
      menuData.forEach(item=>{
        let menuId = item.menuId + ''
        // if (num == 1 && menuId.length<4) {
        //   arr.push(item)
        // } else if(num==2) {
        //   arr.push(item)
        // } else {
          
        // }
        arr.push(item)
      })
      arr.forEach((el,index)=>{
        arr[index].children = []
      })
      menuData.forEach(item=>{
        arr.forEach((el,index)=>{
          if(el.menuId == item.parentId){
          arr[index].children.push(item)
          }
        })
      })
      return arr
    },
    // 获取详情
    getSysRoleDetail() {
      getSysRoleDetail({ roleId: this.roleId }).then((res) => {
        if (res.code === 1) {
          // this.defaultChecked = res.data.filter(
          //   (res) => res.permissionType == this.menuType
          // ); 
          // console.log(res.data)

          let defaultCheckeds = res.data.map((item) => item.menuId);
          defaultCheckeds.forEach((value) => {
            this.$refs.gltree.setChecked(value, true, false);
          });
          this.setSectedMenuList();

        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tree-box {
  height: 35vh;
  overflow: auto;
}

</style>
